import React from "react";
import Head from 'next/head';
import Page from "../components/page";
import { Container, Row, Col, NavLink } from 'reactstrap';
import getConfig from 'next/config';
import DataFetcher from "../util/dataFetcher";
import { SiteChrome, SiteData } from '../components/chrome/layout';
import RenderByDeviceType from '../components/common/renderByDeviceType';
import Slider from 'react-slick';
import ProgramPanel from '../components/chrome/elements/panels/programPanel';

const config = getConfig().publicRuntimeConfig;

const carouselData = {
	items: [
		{
			"src": {
				"mobile": `${config.cdnUrl}/static/images/Lets+Give+Hope/Banner-Mob-MDM.png`,
				"desktop": `${config.cdnUrl}/static/images/Lets+Give+Hope/Banner-Desk-MDM-white.png`
			},
			"altText": "Help fund a mid-day meal"
		},
		{
			"src": {
				"mobile": `${config.cdnUrl}/static/images/Lets+Give+Hope/Banner-Mob-Elderly.png`,
				"desktop": `${config.cdnUrl}/static/images/Lets+Give+Hope/Banner-Desk-Elderly-white.png`
			},
			"altText": "Help an elderly live with dignity"
		},
		{
			"src": {
				"mobile": `${config.cdnUrl}/static/images/Lets+Give+Hope/Banner-Mob-Edu.png`,
				"desktop": `${config.cdnUrl}/static/images/Lets+Give+Hope/Banner-Desk-Edu-white.png`
			},
			"altText": "Help fund a child's education"
		}
	]
};

const navBarTabData = {
	causes: [
		{
			name: "children",
			programs: ["Support non formal education of marginalized children", "Support livelihood for women living in construction sites", "Support living expenses of children in a shelter home"]
		},
		{
			name: "education",
			programs: ["Sponsor college education for a meritorious girl", "Support education of children in a shelter home", "Fund after school classes to bridge learning gaps"]
		},
		{
			name: "mid-day meals",
			programs: ["Feed nutritious meals to a poor rural child"]
		},
		{
			name: "elderly",
			programs: ["Support poor elderly women with a safe shelter in their old age", "Feed a grandparent through a community kitchen", "Sponsor the food and medical needs of a poor senior citizen"]
		},
		{
			name: "health",
			programs: ["Support the treatment of a baby at risk", "Provide nutrition support for a HIV positive child"]
		}
	]
};

export default class HelpNow extends Page {
	state = {
		specialTag: this.props.specialTag || null,
		data: this.props.data || null,
		error: this.props.error || null,
		sortBy: "Relevance",
		AB: this.props.AB || null,
		activeIndex: 0
	};

	// TODO Add component did mount data fetching
	static async getInitialProps({ req, res }) {
		const props = await super.getInitialProps({ req, res });
		props.pageType = "helpnow";
		// FIXME - Why not do all this in the backend? Just return the final tag to the front end?
		props.data = await this.fetchCauseData(req);
		return props;
	}

	static fetchCauseData = async (req) => {
		let data = [];
		for (let i = 0; i < navBarTabData.causes.length; i++) {
			const causeData = {
				name: navBarTabData.causes[i].name,
				programData: await DataFetcher.getProgramsByName(navBarTabData.causes[i].programs, { req })
			}
			data.push(causeData);
		}
		return data;
	}

	onSubcauseClicked = async (event, index) => {
		event.preventDefault();

		this.setState({
			activeIndex: index,
		})
	}

	render() {
		const { session } = this.props;
		const store = {
			...this.props.store,
		};

		const sliderSettings = {
			arrows: false,
			dots: true,
			infinite: true,
			speed: 500,
			autoplay: true,
			autoplaySpeed: 5000,
			slidesToShow: 1,
			slidesToScroll: 1
		};

		const slides = carouselData.items.map((item, index) => {
			const mobile = (<img className="pointer w-100" src={item.src.mobile} alt={item.altText} />);
			const desktop = (<img className="pointer w-100" src={item.src.desktop} alt={item.altText} />);

			return (
				<div key={index}>
					<RenderByDeviceType mobile={mobile} desktop={desktop} />
				</div>
			);
		});

		return (
			<SiteData store={store}>
				<SiteChrome session={session}>

					<Head>
						<title>Lets Give Hope | GiveIndia</title>
						<link rel="canonical" href={this.props.store.canonicalUrl} />
					</Head>

					<Container fluid className="p-0 carousel-let-give">

						<div className="d-flex w-100 justify-content-center helpnow-carousel">
							<Slider {...sliderSettings}>
								{slides}
							</Slider>
						</div>

						<div className="hide-for-mobile" style={{marginTop: '-8px'}}>
							<Row className="w-100 d-flex px-4" style={{ background: "#ff5050", zIndex: 10 }}>
								<div className="subcategory-navbar d-flex align-self-center mt-1" style={{ flexGrow: 1 }}>
									{
										navBarTabData.causes.map((obj, index) => {
											return (
												<div key={index} className="d-flex px-2">
													<NavLink style={{ display: "flex", alignItems: "center", whiteSpace: 'nowrap', textTransform: "capitalize" }} key={index} className={index === this.state.activeIndex ? 'category-cause-link-active' : 'category-cause-link'} onClick={(event) => this.onSubcauseClicked(event, index)}>
														{obj.name}
													</NavLink>
												</div>
											)
										})
									}
								</div>
							</Row>

							<Col md={12} lg={12}>
								<ProgramPanel
									title=""
									viewAll='/search'
									programs={this.props.data[this.state.activeIndex].programData}
									session={this.props.session}
									width={this.props.width}
								/>
							</Col>
						</div>
						<div className="hide-for-desktop mt-4">
							{
								this.props.data.map((obj, index) => {
									return (
										<div key={index} className="px-3">
											<h2 style={{ textTransform: "capitalize" }}>{obj.name}</h2>
											<ProgramPanel
												title=""
												viewAll='/search'
												programs={this.props.data[index].programData}
												session={this.props.session}
												width={this.props.width}
											/>
										</div>
									)
								})
							}
						</div>
					</Container>
					<Container>
						<div style={{ marginTop: '2rem' }}>
							<h2 className="letgivehope-heading">About GiveIndia</h2>
							<div className="letgivehope-details">
								<p >GiveIndia is India's largest and most trusted giving platform that allows you to support a cause of your choice.
									We work with 200+ NGO partners across 23 states in India that have cleared an exhaustive due diligence process covering legal, financial and implementation aspects
												</p>
							</div>
						</div>
						<div>
							<Row className="text-center guide-row d-flex justify-content-center">
								<Col xs="12" sm="12" md="4" lg="4" className=""  >
									<div style={{ padding: '1.5rem' }}>
										<img className="letgivehope-about-giveindia-image" src={`${config.cdnUrl}/static/images/Lets+Give+Hope/giveindia-icons_trust.svg`} alt="GiveIndia Trust" />
										<h4 className=" letgivehope-about-giveindia-heading">Trust</h4>
										<p>Extensive verification processes make sure that your donations reach the right people</p>
									</div>
								</Col>

								<Col xs="12" sm="12" md="4" lg="4" className="" >
									<div style={{ padding: '1.5rem' }}>
										<img className="letgivehope-about-giveindia-image" src={`${config.cdnUrl}/static/images/Lets+Give+Hope/giveindia-icons_report.svg`} alt="GiveIndia Report" />
										<h4 className="letgivehope-about-giveindia-heading">Reports</h4>
										<p>Regular reports on the programs you support every month</p>
									</div>
								</Col>

								<Col xs="12" sm="12" md="4" lg="4" className="" >
									<div style={{ padding: '1.5rem' }}>
										<img className="letgivehope-about-giveindia-image" src={`${config.cdnUrl}/static/images/Lets+Give+Hope/giveindia-icons_tax.svg`} alt="GiveIndia Tax" />
										<h4 className="letgivehope-about-giveindia-heading">Tax Exemption</h4>
										<p>All donations to GiveIndia are eligible for 50% tax exemption under section 80G</p>
									</div>
								</Col>
							</Row>


						</div>


					</Container>


					<style global jsx>
						{
							`
								.helpnow-carousel .slick-slider {
									width: 100%;
								}

								.helpnow-carousel .slick-dots {
									bottom: 5px;
								}

								.helpnow-carousel .slick-dots li button:before {
									font-size: 20px;
								}

								@media(min-width: 576px) {
									.helpnow-carousel .slick-dots {
										bottom: 20px;
									}
								}

									@media(max-width: 576px) {
										.carousel-let-give	.carousel-inner{
												height: auto!important;
											}
											.letgivehope-details{
												padding: 0rem!important;
											  }
											.letgivehope-heading{
												text-align: left !important;
											}
										}

									.letgivehope-details{
                                          padding: 0rem 4rem 0rem 4rem;
									}
									.letgivehope-heading{
										text-align: center;
									}

									.letgivehope-about-giveindia-image{
										width: 100px !important;
										height: 100px;
									}
									.letgivehope-about-giveindia-heading{
										padding-top: 1rem;
									}
									carousel-let-give .carousel-control-next-icon{
										background-image: url("https://cdn.givind.org/static/images/mail/newsletter-2nd-aug-2018/divider.png");
									}

									.category-cause-link {
										cursor: pointer;
										color: white !important;
									}
									
									`
						}
					</style>
				</SiteChrome>
			</SiteData>
		);
	}
}
